var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RegisterUser } from "../../redux/actions/authentication";
import Button from "../atoms/button/button";
import LeftCoverImage from "../atoms/leftCoverImage/leftCoverImage";
import InputField from "../molecules/inputField/inputField";
import BrandHeader from "../molecules/brandHeader/brandHeader";
import "../styles/main.css";
import "../styles/login.css";
import LoginTemplate from "../templates/loginTemplate";
import ErrorMessage from "../atoms/errorMessage/errorMessage";
import { validateFormData } from "./questionnaire/questionnaires/validationUtils";
import showPopupModal from "../../redux/actions/popupModal";
import TermsAndConditionsContent from "./termsAndConditions/TermsAndConditionsContent";
import PrivacyPolicyContent from "./privacyPolicy/PrivacyPolicyContent";
import { ButtonType } from "../atoms/button/buttonType";
import participantInfoPdf from "../../assets/PIS_2BConsent_Form.pdf";
/**
 * The Login Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function Register() {
    var _this = this;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var searchParams = useSearchParams()[0];
    var token = searchParams.get("token");
    var success = useSelector(function (state) { return state.rootReducer.userReducer.registerSuccess; });
    var apiError = useSelector(function (state) { return state.rootReducer.userReducer.error_register; });
    if (success) {
        navigate("/");
    }
    if (token == undefined || token === "") {
        navigate("/");
    }
    //creating react state hook to store username and password locally
    var _a = useState({
        username: "",
        password: "",
        confirmpassword: "",
    }), loginData = _a[0], setLoginData = _a[1];
    var _b = useState({
        username: "",
        password: "",
    }), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = useState(false), termsAccepted = _c[0], setTermsAccepted = _c[1];
    var _d = useState(false), privacyAccepted = _d[0], setPrivacyAccepted = _d[1];
    var _e = useState(false), participantInfoReviewed = _e[0], setParticipantInfoReviewed = _e[1];
    //function to submit the input user data
    var handleSubmit = function (e) {
        var _a;
        e.preventDefault();
        var trimmedData = __assign(__assign({}, loginData), { username: loginData.username.trim() });
        var validation = validateFormData(trimmedData);
        if (!(validation === null || validation === void 0 ? void 0 : validation.isValid)) {
            var errorId = validation === null || validation === void 0 ? void 0 : validation.errorField;
            setErrorMessage(__assign(__assign({}, errorMessage), (_a = {}, _a[errorId] = validation === null || validation === void 0 ? void 0 : validation.errorMessage, _a)));
        }
        else {
            dispatch(RegisterUser(trimmedData.username, loginData.password, token));
        }
    };
    //function to change the values in the input fields entered by the user
    var handleChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setLoginData(__assign(__assign({}, loginData), (_a = {}, _a[name] = value, _a)));
    };
    var handleDownload = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var res, blob, url, a, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(participantInfoPdf)];
                case 2:
                    res = _a.sent();
                    if (!res.ok) {
                        window.location.href = participantInfoPdf;
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, res.blob()];
                case 3:
                    blob = _a.sent();
                    url = URL.createObjectURL(blob);
                    a = document.createElement("a");
                    a.href = url;
                    a.download = "Participant_Information_Sheet.pdf";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    window.location.href = participantInfoPdf;
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    //navigation to dashboard page on successful login
    return (_jsx(LoginTemplate, { leftImage: _jsx(LeftCoverImage, {}), form: _jsxs("form", __assign({ onSubmit: handleSubmit, className: "form mx-auto px-4 sm:px-6" }, { children: [_jsx(BrandHeader, {}), _jsx("h1", __assign({ className: "heading mt-5 text-2xl sm:text-3xl font-bold" }, { children: "Setup Account" })), _jsx("div", __assign({ className: "h3 mb-3 mt-1 font-medium text-gray-600 text-sm sm:text-base" }, { children: "Welcome aboard! Let's kickstart your journey by setting up your account" })), apiError && (_jsx("div", __assign({ className: "mb-3 p-3 bg-red-100 border border-red-400 text-red-700 rounded" }, { children: _jsx(ErrorMessage, { message: apiError }) }))), _jsxs("div", __assign({ className: "space-y-4 mt-4" }, { children: [_jsx(InputField, { label: "Username", type: "text", id: "id_username", name: "username", placeholder: "", value: loginData.username, onChange: handleChange, className: "login w-full" }), !loginData.username ? (_jsx(ErrorMessage, { message: "This field is required*" }, "username")) : (""), _jsx(InputField, { label: "Password", type: "password", id: "id_password", name: "password", placeholder: "", value: loginData.password, onChange: handleChange, className: "login w-full" }), !loginData.password ? (_jsx(ErrorMessage, { message: "This field is required*" }, "password")) : (""), _jsx(InputField, { label: "Confirm Password", type: "password", id: "id_password", name: "confirmpassword", placeholder: "", value: loginData.confirmpassword, onChange: handleChange, className: "login w-full" }), loginData.password !== loginData.confirmpassword ? (_jsx(ErrorMessage, { message: "Password do not match!" }, "password")) : ("")] })), _jsxs("div", __assign({ className: "flex flex-col gap-3 mt-4 text-sm sm:text-base" }, { children: [_jsxs("label", __assign({ className: "flex items-center gap-2 cursor-pointer" }, { children: [_jsx("input", { type: "checkbox", className: "flex-shrink-0", checked: termsAccepted, onChange: function (e) { return setTermsAccepted(e.target.checked); } }), _jsxs("span", { children: ["I agree to MyEmploy's", " ", _jsx("button", __assign({ type: "button", className: "text-blue-600 underline font-medium hover:text-blue-700", onClick: function (e) {
                                                e.preventDefault();
                                                dispatch(showPopupModal(true, _jsxs("div", __assign({ style: { width: "100%", maxWidth: "600px" } }, { children: [_jsx("h2", __assign({ style: {
                                                                marginBottom: "16px",
                                                                fontSize: "18px",
                                                                fontWeight: "600",
                                                            } }, { children: "Terms and Conditions" })), _jsx("div", __assign({ style: {
                                                                maxHeight: "60vh",
                                                                overflowY: "auto",
                                                                marginBottom: "16px",
                                                            } }, { children: _jsx(TermsAndConditionsContent, { minimal: true }) }))] }))));
                                            } }, { children: "Terms and Conditions" }))] })] })), _jsxs("label", __assign({ className: "flex items-center gap-2 cursor-pointer" }, { children: [_jsx("input", { type: "checkbox", className: "flex-shrink-0", checked: privacyAccepted, onChange: function (e) { return setPrivacyAccepted(e.target.checked); } }), _jsxs("span", { children: ["I agree to MyEmploy's", " ", _jsx("button", __assign({ type: "button", className: "text-blue-600 underline font-medium hover:text-blue-700", onClick: function (e) {
                                                e.preventDefault();
                                                dispatch(showPopupModal(true, _jsxs("div", __assign({ style: { width: "100%", maxWidth: "600px" } }, { children: [_jsx("h2", __assign({ style: {
                                                                marginBottom: "16px",
                                                                fontSize: "18px",
                                                                fontWeight: "600",
                                                            } }, { children: "Privacy Policy" })), _jsx("div", __assign({ style: {
                                                                maxHeight: "60vh",
                                                                overflowY: "auto",
                                                                marginBottom: "16px",
                                                            } }, { children: _jsx(PrivacyPolicyContent, { minimal: true }) }))] }))));
                                            } }, { children: "Privacy Policy" }))] })] })), _jsxs("label", __assign({ className: "flex items-center gap-2 cursor-pointer" }, { children: [_jsx("input", { type: "checkbox", className: "flex-shrink-0", checked: participantInfoReviewed, onChange: function (e) { return setParticipantInfoReviewed(e.target.checked); } }), _jsxs("span", { children: ["I have reviewed the", " ", _jsx("a", __assign({ type: "button", className: "text-blue-600 underline font-medium hover:text-blue-700", href: participantInfoPdf, onClick: handleDownload, download: "Participant_Information_Sheet.pdf", rel: "noopener noreferrer" }, { children: "Participant Information Sheet" })), " ", "before setting up my account"] })] }))] })), _jsx("div", __assign({ className: "pt-4 sm:pt-6" }, { children: _jsx(Button, { border: "none", onClick: function () { return handleSubmit; }, text: "Setup Account", className: "w-full mt-4 sm:mt-6", buttonType: ButtonType.Primary, disabled: !termsAccepted || !privacyAccepted || !participantInfoReviewed }) }))] })) }));
}
export default Register;
